// Business Profile constants with no fetching behind them, so pure modules
// (the chat card model, the dashboard) can import them without loading auth.

/** What a photo may be filed under (gbp_edits.PHOTO_CATEGORIES). Cover, profile
 *  and logo are left to the owner on Google: they replace the profile's look. */
export const GBP_PHOTO_CATEGORIES = [
  { value: "EXTERIOR", label: "Outside the business" },
  { value: "INTERIOR", label: "Inside the business" },
  { value: "PRODUCT", label: "A product" },
  { value: "AT_WORK", label: "At work" },
  { value: "FOOD_AND_DRINK", label: "Food and drink" },
  { value: "MENU", label: "Menu" },
  { value: "COMMON_AREA", label: "Common area" },
  { value: "ROOMS", label: "Rooms" },
  { value: "TEAMS", label: "The team" },
  { value: "ADDITIONAL", label: "Something else" },
] as const;

export type GbpPhotoCategory = (typeof GBP_PHOTO_CATEGORIES)[number]["value"];
